import {fetchWrapper} from "../../helpers/fetch.wrapper";

const baseUrl = process.env.REACT_APP_BASE_URL;
export const authService = {
    login,
    registration,
    resetPassword,
    checkToken,
    changePassword,
    updateProfile,
    lookUpAccount,
    updateWynshopLoyaltyId,
    deleteCustomerRecord,
    sendEmailVerifyLink,
    getSubscriptionStatus,
    updateSubscription,
    reportDiscrepancy,
    getKlaviyoSuppressionStatus,
    unsuppressKlaviyoProfile,
    isAccountBlocked,
    unblockAccount
}

async function login(loginDetail) {
    return fetchWrapper.post(`${baseUrl}/customer/authenticate`,
        loginDetail)
        .then(response => {
            return response;
        });
}

async function registration(registrationDetails) {

    return fetchWrapper.post(`${baseUrl}/customer/registration`,
        registrationDetails)
        .then(response => {
            return response;
        });
}

async function lookUpAccount(lookUpData) {

    return fetchWrapper.get(`${baseUrl}/admin/member/lookup/details?fieldType=${encodeURIComponent(lookUpData.fieldType)}&searchValue=${encodeURIComponent(lookUpData.searchValue)}`)
        .then(response => {
            return response;
        });
}

async function deleteCustomerRecord(email) {

    return fetchWrapper.post(`${baseUrl}/admin/delete/profile/${email}`, {})
        .then(response => {
            return response;
        });
}

async function updateWynshopLoyaltyId(customerId) {

    return fetchWrapper.post(`${baseUrl}/admin/wynshop/fix/loyalty-id/${customerId}`, {})
        .then(response => {
            return response;
        });
}

async function updateProfile(updateDetails) {

    return fetchWrapper.post(`${baseUrl}/admin/customer/update`, updateDetails)
        .then(response => {
            return response;
        });
}


async function resetPassword(userId) {
    return fetchWrapper.post(
        `${baseUrl}/admin/reset-password`, {userId}
    ).then(response => {
        return response;
    });
}


async function sendEmailVerifyLink(userId) {
    return fetchWrapper.post(
        `${baseUrl}/admin/email-verification-link?userId=${encodeURIComponent(userId)}`
    ).then(response => {
        return response;
    });
}

async function getSubscriptionStatus(lookUpData) {

    return fetchWrapper.get(`${baseUrl}/admin/member/subscriptions?fieldType=${encodeURIComponent(lookUpData.fieldType)}&searchValue=${encodeURIComponent(lookUpData.searchValue)}`)
        .then(response => {
            return response;
        });
}

async function updateSubscription(subscriptionRequest) {

    return fetchWrapper.post(`${baseUrl}/admin/member/subscriptions`, subscriptionRequest)
        .then(response => {
            return response;
        });
}

async function reportDiscrepancy(discrepancyDetails) {

    return fetchWrapper.post(`${baseUrl}/admin/customer/discrepancy`, discrepancyDetails)
        .then(response => {
            return response;
        });
}

async function getKlaviyoSuppressionStatus(email) {

    return fetchWrapper.get(`${baseUrl}/admin/member/suppression?email=${encodeURIComponent(email)}`)
        .then(response => {
            return response;
        });
}

async function unsuppressKlaviyoProfile(email) {

    return fetchWrapper.post(`${baseUrl}/admin/member/suppression/unsuppress?email=${encodeURIComponent(email)}`, {})
        .then(response => {
            return response;
        });
}

async function isAccountBlocked(customerId) {

    return fetchWrapper.get(`${baseUrl}/admin/customer/${customerId}/blocked`)
        .then(response => {
            return response;
        });
}

async function unblockAccount(customerId) {

    return fetchWrapper.post(`${baseUrl}/admin/customer/${customerId}/unblock`, {})
        .then(response => {
            return response;
        });
}

async function checkToken() {

    return fetchWrapper.post(`${baseUrl}/customer/check-token`)
        .then(response => {
            return response;
        });
}

async function changePassword(changePassword) {

    return fetchWrapper.post(`${baseUrl}/customer/change-password`,
        changePassword)
        .then(response => {
            return response;
        });
}
